<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <card-list-info header="Address" :items="addressInfo"></card-list-info>
      </div>
    </div>
  </div>
</template>
<script>
import CardListInfo from '@/components/CardListInfo';

export default {
  components: {
    CardListInfo,
  },
  created() {
    this.$store.dispatch('customers/LOAD_DETAIL_DATA');
  },
  computed: {
    displayName() {
      const { name = '' } = this.detailedInfo;
      return name;
    },
    detailedInfo() {
      return this.$store.getters['customers/get_detail_data'];
    },
    addressInfo() {
      let { address } = this.detailedInfo;
      address = address || {};

      const infoList = [
        { key: 'country', label: 'Country', value: address.country },
        { key: 'state', label: 'State', value: address.state },
        { key: 'city', label: 'City', value: address.city },
        { key: 'address1', label: 'Address 1', value: address.address1 },
        { key: 'address2', label: 'Address 2', value: address.address2 },
        { key: 'zip_code', label: 'Zip Code', value: address.zip_code },
      ];

      return infoList;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/shipment_md/customers/detail/Preview.vue